export default class DocumentTypes {
  static INVOICE = "invoice";

  static BILL = "bill";

  static CREDIT_NOTE = "creditNote";

  static RECEIPT = "receipt";

  static SALES_RECEIPT = "salesReceipt";

  static OTHER = "other";
}
